import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import type { ApiArea } from '../types';

import i18n from '../../../i18n';

export interface UseAreasOptions {
    ids?: string[];
    enabled?: boolean;
}

export function useAreas(options: UseAreasOptions = {}) {
    const { ids, enabled = true } = options;

    return useQuery({
        queryKey: ['areas', i18n.language, { ids }],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (ids && ids.length > 0) params.set('ids', ids.join(','));

            const res = await api.get<ApiArea[]>(`/api/areas?${params.toString()}`);
            return (res.data || res as any) as ApiArea[];
        },
        enabled
    });
}

export function useArea(slug: string | undefined) {
    return useQuery({
        queryKey: ['area', slug, i18n.language],
        queryFn: async () => {
            const res = await api.get<ApiArea>(`/api/areas/${slug}`);
            return res.data!;
        },
        enabled: !!slug,
    });
}
